import { createHistory, useBasename, useQueries } from 'history';
import { useRouterHistory } from 'react-router';

export default useQueries( useBasename( useRouterHistory(createHistory) ) )({
    basename: '/booking'
});



// WEBPACK FOOTER //
// ./client/core/history.js